import { useParams } from "react-router-dom";
import { useGetSmsCampaignDetails } from "../../../../../hooks/api/queries/useMarketing";
import secondaryComponents from "../../../../../components/secondaryComponents";
import { SmsCampaignReviewForm } from "../../../../../components/secondaryComponents/SmsCampaign";

const SmsCampaignReview = () => {
  const { id } = useParams();
  const { data: smsCampaign, isLoading } = useGetSmsCampaignDetails({ id });

  return (
    <section>
      <secondaryComponents.LoaderHelper
        classNames={"mt-5"}
        isLoading={isLoading}
      >
        <SmsCampaignReviewForm smsCampaign={smsCampaign} />
      </secondaryComponents.LoaderHelper>
    </section>
  );
};

export default SmsCampaignReview;
